import React, { useState } from 'react'
import styled from 'styled-components'
import SocialSection from './SocialSection'
import { ImCross } from 'react-icons/im';
import { BsList } from 'react-icons/bs';
import {Link} from 'react-scroll'

export default function Nav() {
    const [navOpen, setNavOpen] = useState(false);

    const handleHam = () => {
        setNavOpen(!navOpen);
    }
    return (
        <Wrapper id="home">
            <div className='ham-icons'>
                {
                    navOpen ? <ImCross id="cross-ham" onClick={handleHam} /> : <BsList onClick={handleHam} />
                }
            </div>
            <nav>
                <ul className={navOpen ? "header-nav show" : "header-nav"}>
                    <li><Link spy={true} offset={50} duration={500} onClick={()=>setNavOpen(false)} smooth={true} to="home">Home</Link></li>
                    <li><Link spy={true} offset={50} duration={500} onClick={()=>setNavOpen(false)} smooth={true} to="about">About</Link></li>
                    <li><Link spy={true} offset={50} duration={500} onClick={()=>setNavOpen(false)} smooth={true} to="skills">Skills</Link></li>
                    <li><Link spy={true} offset={50} duration={500} onClick={()=>setNavOpen(false)} smooth={true} to="education">Education</Link></li>
                    <li><Link spy={true} offset={50} duration={500} onClick={()=>setNavOpen(false)} smooth={true} to="experience">Experience</Link></li>
                    <li><Link spy={true} offset={50} duration={500} onClick={()=>setNavOpen(false)} smooth={true} to="Certification">Certification</Link></li>
                    <li><Link spy={true} offset={50} duration={500} onClick={()=>setNavOpen(false)} smooth={true} to="project">Projects</Link></li>
                    <li><Link spy={true} offset={50} duration={500} onClick={()=>setNavOpen(false)} smooth={true} to="contact">Contact</Link></li>
                </ul>
            </nav>
            <div id="social-section">
                <SocialSection />
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.section`
    background-image: url(https://ninjasfiles.s3.amazonaws.com/asset_0000000000000020_1549743985_macbook_mouse.jpg);
    height: 65vh;
    position: relative;
    padding-top: 1rem;
    background-size: cover;
    background-attachment: fixed;
    opacity: .8;
    .header-nav {
        height: 20%;
        display: flex;
        gap: 1.4rem;
        justify-content: center;
        list-style: none;
    }
    svg{
        color: white;
    }
    .ham-icons{
        position absolute;
        top: 5%;
        left: 2%;
        display: none;
    }
    .header-nav a {
        text-decoration: none;
        cursor: pointer;
        color: white;
        transition: color .5s, border-bottom 4s;
    }
    
    .header-nav a:hover {
        color: lightgrey;
        border-bottom: 1px solid white;
    }
    
    #social-section {
        color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 80%;
    }
    
    #social-section h1 {
        font-size: 3rem;
        letter-spacing: .1rem;
    }
    
    .social-icons {
        display: flex;
        gap: 1rem;
        list-style: none;
        justify-content: center;
    }
    
    .social-icons svg {
        color: white;
        width: 20px;
        height: 20px;
        padding: 10px;
        border-radius: 50%;
    }
    
    .social-icons svg:hover {
        transition: border-radius .4s, box-shadow .5s;
        box-shadow: 0px 0px 15px 4px rgba(230, 196, 196, 0.3);
    }

    @media only screen and (max-width: 750px){
        z-index: 10;
        .header-nav{
            display: none;
            position: absolute;
            top: -5%;
            left: 0;
            background: white;
        }
        #cross-ham{
            
            color: black;
        }
        .ham-icons{
            display: block;
            svg{
                position: absolute;
                z-index: 10;
            }
        }
        .show{
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 95vw;
            height: 100vh;
            li{
                text-align:center;
                a{
                color: black;
                font-size: 2rem;
                }
            }
        }
        #social-section{
            h1{
                font-size: 2rem;
            }
        }
    }
`